/* eslint class-methods-use-this: ["error", { "exceptMethods": ["registFunc"] }] */
import Vue from 'vue';
import Component from 'vue-class-component';
import { Ref } from 'vue-property-decorator';
import { mapState } from 'vuex';

import * as constant from '@/constant';
import { GLOBAL } from '@/constant';
import { getAdapter, env, ZYToast } from '@zyf2e/adapt';
import * as utils from '@/utils';
import * as Telescope from '@zyf2e/telescope';
import { dispatchGetLocation, commitSetLocation } from '@/store/global';

export const UPDATE_LIST_REF_KEY = 'UPDATE_LIST_REF_KEY';

interface IemitFuncList {
  type: string;
  func: Function;
}

const emitFuncList: Array<IemitFuncList> = [];

let timer: NodeJS.Timeout;

const adapter = getAdapter();

adapter.goIM = function goIM(param, type): void {
  if (type === 'replace') {
    this.replace(
      `${location.protocol}//static${
        env.devEnv ? `.${env.devEnv}` : ''
      }.91jkys.com/f2e/kangm-customer-h5-im/#/chat/chatCore?${this.qs.stringify({
        ...param,
        to: param.toId
      })}`
    );
    return;
  }
  this.redirect(
    `${location.protocol}//static${
      env.devEnv ? `.${env.devEnv}` : ''
    }.91jkys.com/f2e/kangm-customer-h5-im/#/chat/chatCore?${this.qs.stringify({
      ...param,
      to: param.toId
    })}`
  );
}


@Component({
  computed: {
    ...mapState(GLOBAL, ['location'])
  }
})
export default class Webview extends Vue {
  location!: string;

  UPDATE_LIST_REF_KEY = UPDATE_LIST_REF_KEY;

  constant = constant;

  telescope = Telescope;

  utils = utils;

  adapter = adapter;

  env = env;

  ZYToast = ZYToast;

  rememberPosition = {
    x: 0,
    y: 0
  };

  activated() {
    const ref = this.$refs.SCROLL_CONTAINER;
    if (!ref) {
      return;
    }
    const scrollContainer = (ref as Vue).$el || ref;
    scrollContainer.scrollTop = this.rememberPosition.y;
  }

  @Ref('SCROLL_CONTAINER')
  SCROLL_CONTAINER_REF?: Vue | HTMLElement;

  HANDLE_SCROLL_CONTAINER_REF() {
    if (!this.SCROLL_CONTAINER_REF) {
      return;
    }
    const scrollContainer = (this.SCROLL_CONTAINER_REF as Vue).$el || this.SCROLL_CONTAINER_REF;
    this.rememberPosition.y = scrollContainer.scrollTop;
  }

  registFunc(params: IemitFuncList) {
    const hasRegist = emitFuncList.some(item => item.type === params.type);
    if (!hasRegist) {
      emitFuncList.push(params);
    }
  }

  async pollGetLoaction(params?: boolean) {
    if (params) {
      await this.getGlobalLocation();
    }
    clearTimeout(timer);
    timer = setTimeout(async () => {
      await this.getGlobalLocation();
      this.pollGetLoaction();
    }, 600000); // 600000
  }

  async getGlobalLocation() {
    try {
      this.ZYToast.setOnceConfig({ noToast: true });
      const { latitude, longitude } = await this.adapter.getLocation();
      const city = await dispatchGetLocation(this.$store, {
        latitude: Number(latitude),
        longitude: Number(longitude)
      });
      if (city && city !== this.location) {
        emitFuncList.forEach(el => el.func());
        this.$toast('地理位置已发生变化，医生列表已更新');
      }
      this.ZYToast.clearOnceConfig();
      commitSetLocation(this.$store, city);
    } catch {
      // do nothing
    }
  }
}
